import Default from "./ErrorBoundary";
export * from "./ErrorBoundary";

export default Default;